module.exports = __webpack_public_path__ + "static/media/662523.8c5fcdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ourStaff/662523.png
// module id = 1434
// module chunks = 0